import { Box } from '@mui/material';
import React, { useContext, useEffect, useRef } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import EmbedContext from '../../context/EmbedContext/EmbedContext';
import styles from './styles';

function FullSizeChatbotPage(): React.ReactElement {
  const { embedIsReady } = useContext(EmbedContext);
  const scriptSrc = process.env.REACT_APP_EMBED_CHATBOT_SRC as string;
  const hasEffectRun = useRef(false);
  const { chatbotUUID } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isTest = queryParams.get('isTest') === 'true';

  const showChatbot = (): void => {
    window.japetoApi?.showChatbot();
  };

  const hideChatbot = (): void => {
    window.japetoApi?.hideChatbot();
  };

  useEffect(() => {
    if (embedIsReady) {
      showChatbot();
    }
    return () => {
      if (embedIsReady) {
        hideChatbot();
      }
    };
  }, [embedIsReady]);

  useEffect(() => {
    if (hasEffectRun.current) return undefined;
    const script = document.createElement('script');
    script.src = scriptSrc;
    document.body.appendChild(script);
    hasEffectRun.current = true;
    return () => {
      const scriptElement = document.querySelector(
        `script[src="${scriptSrc}"]`
      ) as HTMLScriptElement;
      if (scriptElement) {
        document.body.removeChild(scriptElement);
      }
    };
  }, []);

  return (
    <Box sx={styles.container}>
      <Box
        id='japeto-root'
        sx={styles.japetoRootDiv}
        data-botid={chatbotUUID}
        data-istest={isTest && 'true'}
        data-botfullwidth='true'
      />
    </Box>
  );
}

export default FullSizeChatbotPage;
